import { useQuery, useMutation, useQueryClient } from 'react-query';
import { deleteDevice, getDevice } from 'lib/api/device';
import { useDispatch } from 'react-redux';
import { changeProp } from 'modules/deviceSlice';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useDeviceRegister = (id, setShowErrorModal) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const getDeviceQuery = useQuery(['device', id], () => getDevice({ id }), {
    onSuccess: data => {
      dispatch(changeProp({ key: 'planList', value: data?.data.plan }));
    },
  });
  useLoginCheck(getDeviceQuery.error?.response, getDeviceQuery.refetch);

  const deleteDeviceMutation = useMutation(deleteDevice, {
    onError: error => {
      if (error.response.status === 500) {
        setShowErrorModal(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('device');
    },
  });
  useLoginCheck(deleteDeviceMutation.error?.response, () => {
    deleteDeviceMutation.mutate({ id });
  });

  const onDelete = () => {
    deleteDeviceMutation.mutate({ id });
  };

  return {
    getDeviceQuery,
    onDelete,
  };
};

export default useDeviceRegister;
